import { dateTime } from "../api.js";

export const ACTIVE = ["queued", "running"];

// Стан розділу одним рядком: коли оновлено, що зараз, яка помилка
export function resourceStatus(res) {
  const j = res?.lastJob;
  if (!j) return { tone: "idle", text: "Ще не синхронізовано" };
  if (ACTIVE.includes(j.status)) return { tone: "busy", text: j.status === "queued" ? "У черзі…" : "Оновлюється…" };
  if (j.status === "needs_login") return { tone: "warn", text: "Потрібен вхід ключем КЕП — після нього синк продовжиться" };
  if (j.status === "failed" || j.status === "unknown_result") {
    return { tone: "bad", text: `Не вдалося оновити: ${j.error || "невідома помилка"}`,
      sub: res.lastSuccessAt ? `Показано дані на ${dateTime(res.lastSuccessAt)}` : null };
  }
  const partial = res.partialErrors?.length || 0;
  return { tone: partial ? "warn" : "ok", text: `Оновлено ${dateTime(res.lastSuccessAt)}`,
    sub: partial ? `Частково: ${partial} помилк${partial === 1 ? "а" : partial < 5 ? "и" : ""}` : null };
}

export function StatusLine({ res }) {
  const s = resourceStatus(res);
  return (
    <p className={`status status-${s.tone}`} aria-live="polite">
      <span className="status-dot" aria-hidden="true" />
      <span>{s.text}{s.sub && <span className="muted"> · {s.sub}</span>}</span>
    </p>
  );
}

// Шапка розділу: назва, стан і джерело даних. Оновлення — однією кнопкою в шапці компанії
// (поточний розділ або всі), тож власної кнопки тут немає
export function SectionHead({ title, res, children }) {
  return (
    <div className="section-head">
      <div className="section-title">
        <h2>{title}</h2>
        <StatusLine res={res} />
        {res?.source === "official" && <p className="notice">Джерело: офіційний API ДПС</p>}
        {res?.source === "internal" && res?.fallback && <p className="notice">Джерело: кабінет ДПС ({res.fallback})</p>}
      </div>
      {children && <div className="actions">{children}</div>}
    </div>
  );
}

// Часткові помилки розділу — розгортаються
export function PartialErrors({ res }) {
  const errs = res?.partialErrors || [];
  if (!errs.length) return null;
  return (
    <details className="errors">
      <summary>Помилки під час останнього оновлення: {errs.length}</summary>
      <ul>{errs.map((e, i) => <li key={i}><code>{e.part}</code> — {e.message}</li>)}</ul>
    </details>
  );
}

export function Empty({ children }) {
  return <p className="empty">{children}</p>;
}

// Коротка назва з повної юридичної — спільна з сервером і тестами (lib/names.js)
export { shortName } from "../../../lib/names.js";

// Сторінки: ‹ 1 … 4 5 6 … 12 ›
export function Pager({ page, pages, total, go, unit = "док." }) {
  const nums = [...new Set([0, pages - 1, page - 1, page, page + 1].filter((n) => n >= 0 && n < pages))].sort((a, b) => a - b);
  const out = []; nums.forEach((n, i) => { if (i && n - nums[i - 1] > 1) out.push("…" + n); out.push(n); });
  return (
    <nav className="pager" aria-label="Сторінки">
      <button type="button" className="btn btn-secondary btn-sm" aria-label="Попередня сторінка" disabled={page === 0} onClick={() => go(page - 1)}>‹</button>
      {out.map((n) => (typeof n === "string" ? <span key={n} className="muted">…</span> : (
        <button type="button" key={n} className={`btn btn-sm ${n === page ? "" : "btn-ghost"}`} aria-current={n === page ? "page" : undefined} onClick={() => go(n)}>{n + 1}</button>
      )))}
      <button type="button" className="btn btn-secondary btn-sm" aria-label="Наступна сторінка" disabled={page + 1 >= pages} onClick={() => go(page + 1)}>›</button>
      <span className="muted small">{total} {unit}</span>
    </nav>
  );
}
